export default {
  total_orders: {
    title: 'Bestellingen',
    orders: 'Bestellingen:',
    sales_volume: 'Verkoopvolume:',
    delivery_costs: 'Bezorgkosten:',
  },
  cash_orders: {
    title: 'Betaling contant / aan de deur',
    orders: 'Bestellingen:',
    sales_volume: 'Verkoopvolume:',
    delivery_costs: 'Bezorgkosten:',
  },
  online_orders: {
    title: 'Online betalingen',
    orders: 'Bestellingen:',
    sales_volume: 'Verkoopvolume:',
    delivery_costs: 'Bezorgkosten:',
  },
  total: 'Totaal',
  collected_taxes_list: {
    title: {
      online: 'Online betaling',
      cash: 'Contante betaling',
    },
    table: {
      products_breakdown: {
        fields: {
          product: 'Product',
          quantity: 'Aantal',
          total: 'Totaal',
        },
        labels: {
          total_refunded: 'Terugbetaald',
        },
      },
      tax_breakdown: {
        fields: {
          tax_percentage: 'Btw %',
          product_type: 'Type',
          netto: 'Netto',
          tax: 'Btw',
          brutto: 'Totaal',
        },
        product_types: {
          product: 'Producten {{percentage}}%',
          order_method_fee: 'Bezorgkosten {{percentage}}%',
          customer_service_fee: 'Online toeslag',
        },
      },
    },
  },
};
